module.exports = __webpack_public_path__ + "static/media/reply-arrow-filled-orange.a54d35b4.svg";